import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {AutoComplete} from "primereact/autocomplete";
import {InputNumber} from "primereact/inputnumber";

const ContractFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [projectTypes, setProjectTypes] = useState([]);
  const [partners, setPartners] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [vatRates, setVatRates] = useState([]);
  const [projectDisplay, setProjectDisplay] = useState("");
  const [projectSuggestions, setProjectSuggestions] = useState([]);
  const [projectSelected, setProjectSelected] = useState(false);
  const [projects, setProjects] = useState([]);
  const [contractType, setContractType] = useState([
    {value: 'MASTER_AGREEMENT', name: 'Keretszerződés'},
    {value: 'STATEMENT_OF_WORK', name: 'Eseti megállapodás'}
  ]);
  const [partnerQuery, setPartnerQuery] = useState(
    window.App.urlVars().partnerName ? decodeURIComponent(window.App.urlVars().partnerName) : ''
  );
  const [partnerLoading, setPartnerLoading] = useState(false);
  const [companys, setCompanys] = useState([]);
  const [types, setTypes] = useState([]);
  const [itemFormData ,setItemFormData] = useState({});
  const [items, setItems] = useState([]);
  const [itemFields, setItemFields] = useState([]);
  const [itemFieldOptions, setItemFieldOptions] = useState([]);
  const [itemScema, setItemScema] = useState('');
  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const getBacklink = () => {
    if (props.view === 'subcontractor' && props.projectId) {
      return '/project/project/read/' + props.projectId;
    }

    return props.backlink;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().contractId) || (window.App.urlVars().contract) || (entity === 'contract' && id && id !== 'undefined')) {
      apiCall('patch', '/api/v2/contract/' + (window.App.urlVars().contractId || window.App.urlVars().contract || id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderContractList: Math.random()})
          if (props.goback === true) {
            history.push(getBacklink());
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      const payload = {
        name: formData.name,
        // project_type: formData.project_type?.id || formData.project_type || null,

        project_type: props.view === 'subcontractor'
          ? props.projectTypeId
          : (formData.project_type?.id || formData.project_type || null),

        partner: formData.partner?.id || formData.partner || null,
        company: formData.company?.id || formData.company || null,
        // type: formData.type?.key || formData.type || null,
        type: props.view === 'subcontractor' ? 'SUBCONTRACTOR' : (formData.type?.key || formData.type || null),
        net_amount: formData.net_amount ?? null,

         project: props.view === 'subcontractor'
          ? props.projectId
          : (
              formData.contract_type === 'STATEMENT_OF_WORK'
                ? (formData.project?.id || formData.project || null)
                : null
            ),

        currency: formData.currency || null,
        vat_rate: formData.vat_rate?.id || formData.vat_rate || null,

        contract_type: props.view === 'subcontractor'
          ? 'STATEMENT_OF_WORK'
          : (formData.contract_type || null),

        description: formData.description || null
      };
      apiCall('post', '/api/v2/contract', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderContractList: Math.random()})
          if (props.goback === true) {
            history.push(getBacklink());
          } else {
            history.push('/project/contract/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const searchPartner = (event) => {
    const q = (event?.query || '').trim();
    setPartnerQuery(q);
    if (q.length < 2) {
      setPartners([]);
      return;
    }
    setPartnerLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/partner", {
      params: {
        rows: 15,
        'search[name][operator]': 'like',
        'search[name][value]': `%${q}%`
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        const items = response?.data?.data?.items || [];
        const mapped = items.map((partner) => ({
          ...partner,
          displayName:
            partner.name +
            (
              partner.address_postal_code || partner.address_city || partner.address_detail
                ? ` (${partner.address_postal_code || ''} ${partner.address_city || ''}, ${partner.address_detail || ''})`
                : ''
            )
        }));
        setPartners(mapped);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setPartnerLoading(false);
      });
  };
  
  const getProjectLocationId = (project) => {
    if (!project) return null;
    if (project.location && typeof project.location === 'object' && project.location.id) {
      return project.location.id;
    }
    if (project.location && (typeof project.location === 'number' || typeof project.location === 'string')) {
      return project.location;
    }
    if (project.location_id) return project.location_id;
    if (Array.isArray(project.locations) && project.locations[0]?.id) {
      return project.locations[0].id;
    }
    return null;
  };

  const applyProjectLocation = (projectOrId) => {
    if (window.App.urlVars().locationId && !id) return;
    let projectObj = null;
    if (typeof projectOrId === 'object') {
      projectObj = projectOrId;
    } else if (projectOrId) {
      projectObj = projects.find(p => String(p.id) === String(projectOrId));
    }
    const locId = getProjectLocationId(projectObj);
    setFormData(prev => ({ ...prev, location: locId || null }));
    setNewFormData(prev => ({ ...prev, location: locId || null }));
  };

  const searchProject = (event) => {
    const query = (event.query || "").toLowerCase().trim();
    if (!query) {
      setProjectSuggestions([]);
      return;
    }
    const filtered = projects
      .filter(p => {
        const name = (p.name || "").toLowerCase();
        return name.includes(query);
      })
      .map(p => ({
        ...p,
        name: p.name
      }));
    setProjectSuggestions(filtered);
  };

  useEffect(() => {
    const partnerId = window.App.urlVars().partnerId;
    const partnerName = window.App.urlVars().partnerName;
    if (partnerId && partnerName) {
      setFormData(prev => ({
        ...prev,
        partner: Number(partnerId)
      }));
      setNewFormData(prev => ({
        ...prev,
        partner: Number(partnerId)
      }));
      setPartnerQuery(decodeURIComponent(partnerName));
    }
  }, [window.location.hash]);

  useEffect(() => {
    const vars = window.App.urlVars();
    if (vars.projectName) {
      const decodedProjName = decodeURIComponent(vars.projectName);
      setProjectDisplay(decodedProjName);
      setFormData(prev => ({
        ...prev,
        project: vars.projectId || prev.project
      }));
      setNewFormData(prev => ({
        ...prev,
        project: vars.projectId || prev.project
      }));
      applyProjectLocation(vars.projectId);
    }
  }, [window.App.urlVars().projectName]);

  useEffect(() => {
    if (props.view === 'subcontractor') {
      setFormData(prev => ({
        ...prev,
        project: props.projectId || prev.project,
        project_type: props.projectTypeId || prev.project_type,
        contract_type: 'STATEMENT_OF_WORK'
      }));

      setNewFormData(prev => ({
        ...prev,
        project: props.projectId || prev.project,
        project_type: props.projectTypeId || prev.project_type,
        contract_type: 'STATEMENT_OF_WORK'
      }));

      if (props.projectName) {
        setProjectDisplay(decodeURIComponent(props.projectName));
      }
    }
  }, [props.view, props.projectId, props.projectName, props.projectTypeId]);

  useEffect(() => {
    if (formData.shortcut_dto_id) {
      apiCall('get', '/api/v2/contract/dto/' + formData.shortcut_dto_id)
        .then(response => {
          setItems(response.data.data.children)
        })
    }
  }, [formData.shortcut_dto_id])

  useEffect(() => {
    apiCall('get', '/api/v2/project-type?' + JSON.stringify({
      first: 0,
      rows: 9999,
      page: 0,
    }))
      .then(response => {
        setProjectTypes(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/dictionary/currency')
      .then(response => {
        setCurrencies(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/project?limit=9999')
      .then(response => {
        setProjects(response.data.data.items)
        if (formData?.project && typeof formData.project === 'object') {
          setProjectDisplay(formData.project.name || "");
        } else if (formData?.project) {
          const hitProj = response.data.data.items.find(p => String(p.id) === String(formData.project));
          if (hitProj) {
            setProjectDisplay(hitProj.name || "");
          }
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/vat-rate')
      .then(response => {
        setVatRates(response.data.data.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/company')
      .then(response => {
        setCompanys(response.data.data.items)
        if (response.data?.data?.items[0]) {
          setFormData(prev => ({
            ...prev,
            company: response.data.data.items[0].id
          }));
          setNewFormData(prev => ({
            ...prev,
            company: response.data.data.items[0].id
          }));
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/dictionary/contract-role')
      .then(response => {
        setTypes(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && (window.App.urlVars().contractId || window.App.urlVars().contract)) || (entity === 'contract' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/contract/' + (window.App.urlVars().contractId || window.App.urlVars().contract || id))
        .then(response => {
          const data = response.data.data;
          setFormData({
            ...data,
            partner: data.partner?.id || data.partner || null,
            project_type: data.project_type?.id || data.project_type || null,
            project: data.project?.id || data.project || null,
            vat_rate: data.vat_rate?.id || data.vat_rate || null
          });
          setNewFormData({});
          setPartnerQuery(data.partner?.name || data.partnerName || '');
          if (data.project?.name) {
            setProjectDisplay(data.project.name);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"contract-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            {props.view !== 'subcontractor' && (
            <div className={"p-col-12 p-lg-4"}>
              <Field name="type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAssignmentType')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(types, "value")}
                               id={"type"}
                               optionValue={"key"}
                               optionLabel={"value"}
                               emptyMessage={t('noTypeYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   type: e.value
                                 })
                                 setNewFormData({
                                   ...newFormData,
                                   type: e.value
                                 })
                               }}
                               value={formData.type?.id || formData.type}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {props.view !== 'subcontractor' && (
            <div className={"p-col-12 p-lg-4"}>
              <Field name="project_type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="project_type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldProjectType')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(projectTypes, "name")}
                               id={"project_type"}
                               disabled={window.App.urlVars().update === 'contract'}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noElementYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   project_type: e.value
                                 })
                                 setNewFormData({
                                   ...newFormData,
                                   project_type: e.value
                                 })
                               }}
                               value={formData.project_type?.id || formData.project_type}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}
            <div className={"p-col-12 p-lg-4"} id="partner">
              <Field name="partner" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="partner" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPartner')}</label>
                  <span className={"p-field p-inputgroup"}>
                      <Button type="button" className={"p-button"}
                              onClick={() => {
                                const currentPath = window.location.hash.replace('#', '').split('?')[0];
                                const currentVars = window.App.urlVars();
                                const nextParams = new URLSearchParams();
                                Object.entries(currentVars).forEach(([key, value]) => {
                                    if (key !== 'formData' && key !== 'search') {
                                        nextParams.append(key, value);
                                    }
                                });
                                nextParams.append('formData', JSON.stringify(formData));
                                nextParams.append('backlink', window.location.hash.replace('#', ''));
                                nextParams.append('search', 'partner');
                                history.push(currentPath + '?' + nextParams.toString());
                              }}>
                        <i className={"pi pi-search"}></i>
                      </Button>
                      <AutoComplete
                                    value={partnerQuery}
                                    id={"partner"}
                                    loading={partnerLoading}
                                    suggestions={partners}
                                    forceSelection
                                    completeMethod={searchPartner}
                                    field={"displayName"}
                                    delay={700}
                                    placeholder={t('typeToSearchPlaceholder')}
                                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                    onSelect={(e) => {
                                      const p = e.value;
                                      if (!p?.id) return;
                                      setPartnerQuery(p.displayName || p.name || '');
                                      setFormData(prev => ({
                                        ...prev,
                                        partner: Number(p.id)
                                      }));
                                      setNewFormData(prev => ({
                                        ...prev,
                                        partner: Number(p.id)
                                      }));
                                    }}
                                    onChange={(e) => {
                                      setPartnerQuery(e.value);
                                      if (!e.value || String(e.value).trim() === '') {
                                        setFormData(prev => ({
                                          ...prev,
                                          partner: null
                                        }));
                                        setNewFormData(prev => ({
                                          ...prev,
                                          partner: null
                                        }));
                                      }
                                    }}
                                    onClear={() => {
                                      setPartnerQuery('');
                                      setFormData(prev => ({
                                        ...prev,
                                        partner: null
                                      }));
                                      setNewFormData(prev => ({
                                        ...prev,
                                        partner: null
                                      }));
                                    }}
                                  />
                              <Button type="button" className={"p-button"}
                                      onClick={() => {
                                        const currentPath = window.location.hash.replace('#', '').split('?')[0];
                                        const currentVars = window.App.urlVars();
                                        const nextParams = new URLSearchParams();
                                        Object.entries(currentVars).forEach(([key, value]) => {
                                            if (key !== 'formData' && key !== 'createPartner') {
                                                nextParams.append(key, value);
                                            }
                                        });
                                        nextParams.append('formData', JSON.stringify(formData));
                                        nextParams.append('backlink', window.location.hash.replace('#', ''));
                                        nextParams.append('createPartner', 'true');
                                        history.push(currentPath + '?' + nextParams.toString());
                                      }}>
                                <i className={"pi pi-plus"}></i>
                              </Button>
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="company" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="company"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCompany')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(companys, "name")}
                               id={"company"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noCompanyYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   company: e.value
                                 })
                                 setNewFormData({
                                   ...newFormData,
                                   company: e.value
                                 })
                               }}
                               value={formData.company?.id || formData.company}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-4"}>
              <Field name="net_amount" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="net_amount"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNetAmount')}</label>
                  <span className="p-d-block">
                     <InputNumber
                        id="net_amount"
                        value={formData.net_amount}
                        minFractionDigits={0}
                        maxFractionDigits={2}
                        mode="decimal"
                        onValueChange={(e) => {
                          setFormData({
                            ...formData,
                            net_amount: e.value
                          });
                          setNewFormData({
                            ...newFormData,
                            net_amount: e.value
                          });
                        }}
                        className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            
            <div className={"p-col-12 p-lg-4"}>
              <Field name="currency" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="currency"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCurrency')}</label>
                  <span className={"p-d-block"}>
                              <Dropdown 
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            currency: e.value
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            currency: e.value
                                          })
                                        }}
                                        value={formData.currency}
                                        options={window.App.sortDropdownOptions(currencies, "key")}
                                        optionLabel="key"
                                        optionValue="key"
                                        id={"currency"}
                                        emptyMessage={t('noCurrencyYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-4"}>
              <Field name="vat_rate" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="vat_rate"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDefaultVatRate')}</label>
                  <span className={"p-d-block"}>
                    <Dropdown
                      {...input}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          vat_rate: e.value
                        })
                        setNewFormData({
                          ...newFormData,
                          vat_rate: e.value
                        })
                      }}
                      value={formData.vat_rate?.id || formData.vat_rate || null}
                      options={window.App.sortDropdownOptions(vatRates, "label")}
                      optionLabel="label"
                      optionValue="id"
                      id={"vat_rate"}
                      emptyMessage={t('noElementYet')}
                      className={classNames({'p-error': isFormFieldValid(meta)})}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            {props.view !== 'subcontractor' && (
            <div className={"p-col-12 p-lg-4"}>
              <Field name="contract_type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="contract_type"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldContractType')}</label>
                  <span className={"p-d-block"}>
                              <Dropdown 
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            contract_type: e.value,
                                            project: e.value === 'STATEMENT_OF_WORK' ? formData.project : null
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            contract_type: e.value,
                                            project: e.value === 'STATEMENT_OF_WORK' ? formData.project : null
                                          })
                                          if (e.value !== 'STATEMENT_OF_WORK') {
                                            setProjectDisplay("");
                                          }
                                        }}
                                        value={formData.contract_type}
                                        options={window.App.sortDropdownOptions(contractType, "name")}
                                        optionLabel="name"
                                        optionValue="value"
                                        id={"contract_type"}
                                        emptyMessage={t('noContractTypeYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}

            {props.view !== 'subcontractor' && formData.contract_type === 'STATEMENT_OF_WORK' && (
            <div className={"p-col-12 p-lg-4"}>
              <Field name="project" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="project"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('project')}</label>
                  <span className="p-inputgroup">
                  <Button
                    type="button"
                    className="p-button"
                    onClick={() => {
                      let paramsObj = {...window.App.urlVars()};
                      paramsObj.search = 'project';
                      let _params = "?";
                      Object.entries(paramsObj).forEach(([key, value]) => {
                        _params += key + "=" + value + "&";
                      });
                      history.push(window.location.hash.replace("#", "") + _params);
                    }}
                  >
                    <i className="pi pi-search"></i>
                  </Button>

                  <AutoComplete
                    id="project"
                    value={projectDisplay}
                    suggestions={projectSuggestions}
                    completeMethod={searchProject}
                    field={"name"}
                    delay={800}
                    forceSelection
                    placeholder={t('projectTypeToSearchPlaceholder')}
                    className={classNames({'p-invalid': isFormFieldValid(meta)})}

                    onSelect={(e) => {
                      const picked = e.value;
                      setProjectSelected(true);
                      setProjectDisplay(picked.name || "");
                      const pickedProjectId = picked.id || null;
                      const pickedLocationId = picked.location?.id || null;
                      setFormData(prev => ({
                        ...prev,
                        project: pickedProjectId,
                        location: pickedLocationId || null
                      }));
                      setNewFormData(prev => ({
                        ...prev,
                        project: pickedProjectId,
                        location: pickedLocationId || null
                      }));
                      applyProjectLocation(picked);
                    }}

                    onChange={(e) => {
                      if (projectSelected) {
                        setProjectSelected(false);
                        return;
                      }
                      setProjectDisplay(e.value);

                      setFormData({
                        ...formData,
                        project: null
                      });
                      setNewFormData({
                        ...newFormData,
                        project: null
                      });
                    }}

                    onClear={() => {

                      setProjectDisplay("");
                      setFormData({
                        ...formData,
                        project: null,
                        location: null
                      });
                      setNewFormData({
                        ...newFormData,
                        project: null,
                        location: null
                      });
                    }}
                  />
                </span>

                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}


            <div className={"p-col-12 p-lg-8"}>
              <Field name="description" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="description"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDescription')}</label>
                  <span className="p-d-block">
                      <InputText id="description" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     description: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     description: e.target.value
                                   })
                                 }}
                                 value={formData.description}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'contract' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(ContractFormComponent);
